import { TaskDocument, VideoTracking } from "@onpreo/database";
import { Range } from "@onpreo/components";

export type VideoTrackingState = Omit<VideoTracking, "createdAt" | "updatedAt" | "user" | "workspace">;

export const initialVideoTrackingState = {
    id: undefined,
    academy: {}
} as VideoTrackingState;
